import { useState } from 'react';
import { Button } from '@jywer/ui';
import { createTemplate, type ProjectType } from './api';

interface CreateTemplateFormProps {
  onCancel: () => void;
  onCreated: () => Promise<void>;
}

const PROJECT_TYPES: Array<{ value: ProjectType; label: string }> = [
  { value: 'website', label: 'Website' },
  { value: 'video', label: 'Video' },
  { value: 'pakkelosning', label: 'Pakkeløsning' },
  { value: 'klippekort', label: 'Klippekort' },
];

export function CreateTemplateForm({ onCancel, onCreated }: CreateTemplateFormProps) {
  const [projectType, setProjectType] = useState<ProjectType>('website');
  const [phase, setPhase] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    if (phase.trim() === '' || name.trim() === '') {
      setErr('Fase og navn er påkrævet');
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      await createTemplate({
        project_type: projectType,
        phase: phase.trim(),
        name: name.trim(),
      });
      await onCreated();
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-2 rounded border border-line-1 bg-paper-1 p-3">
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        <label className="flex flex-col gap-1 text-meta text-ink-2">
          Projekttype
          <select
            value={projectType}
            onChange={(e) => setProjectType(e.target.value as ProjectType)}
            className="rounded-token-md border border-line-2 bg-paper-0 px-2 py-1 text-ui text-ink-0"
          >
            {PROJECT_TYPES.map((p) => (
              <option key={p.value} value={p.value}>
                {p.label}
              </option>
            ))}
          </select>
        </label>
        <label className="flex flex-col gap-1 text-meta text-ink-2">
          Fase (fx kickoff_booket, lock_2)
          <input
            type="text"
            value={phase}
            onChange={(e) => setPhase(e.target.value)}
            placeholder="lock_2"
            className="rounded-token-md border border-line-2 bg-paper-0 px-2 py-1 text-ui text-ink-0"
          />
        </label>
        <label className="flex flex-col gap-1 text-meta text-ink-2">
          Navn
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Lock 2 — Design + Copy"
            className="rounded-token-md border border-line-2 bg-paper-0 px-2 py-1 text-ui text-ink-0"
          />
        </label>
      </div>
      <div className="flex items-center justify-between gap-2">
        <span className="text-meta text-status-err">{err ?? ' '}</span>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onCancel} disabled={busy}>
            Annullér
          </Button>
          <Button size="sm" onClick={submit} disabled={busy}>
            {busy ? 'Opretter…' : 'Opret skabelon'}
          </Button>
        </div>
      </div>
    </div>
  );
}
